import styles from "./Testimonies.module.scss";
import iconStyles from "../../../components/Icon.module.scss";
import buttonStyles from "../../../components/Button.module.scss";

const Testimonies = () => {
  return (
    <section id="testimonies" className={styles.testimonies}>
      <div className={styles.title}>
        <h2>
          Testimonies by
          <br />
          members &amp; visitors
        </h2>
      </div>
      <div className={styles.wrapper}>
        <div className={styles["card-container"]}>
          <div className={styles.column}>
            <div className={styles.card}>
              <div className={styles.subtitle}>
                <div className={styles.profile}>S</div>
                <p>Samuel Wijaya</p>
              </div>
              <div className={styles.text}>
                <h6>
                  A loving community with a sound teaching. While in Stockholm I
                  had been greatly blessed by God through the sermons, the
                  fellowships and the kindness of the people here.
                </h6>
              </div>
            </div>
          </div>
          <div className={styles.column}>
            <div className={styles.card}>
              <div className={styles.subtitle}>
                <div className={`${styles.profile} ${styles.dark}`}>D</div>
                <p>Daniel Selvaratnam</p>
              </div>
              <div className={styles.text}>
                <h6>
                  A loving and faithful church teaching solid reformed doctrine,
                  with extremely welcoming people. Hard to find a church like
                  this in Stockholm.
                </h6>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.subtitle}>
                <div className={styles.profile}>M</div>
                <p>Maruli Siboro</p>
              </div>
              <div className={styles.text}>
                <h6>Great teaching and a friendly, lively congregation</h6>
              </div>
            </div>
          </div>
          <div className={styles.column}>
            <div className={styles.card}>
              <div className={styles.subtitle}>
                <div className={styles.profile}>B</div>
                <p>Billy Kristanto</p>
              </div>
              <div className={styles.text}>
                <h6>
                  A hospitable Christian community with Reformed teaching and
                  zeal for the Gospel. Sermons are mostly expository.
                </h6>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.subtitle}>
                <div className={`${styles.profile} ${styles.dark}`}>J</div>
                <p>Jeremy Sintong</p>
              </div>
              <div className={styles.text}>
                <h6>
                  Warm and Kind-Hearted Church Community with International
                  Fellowship
                </h6>
              </div>
            </div>
          </div>
          <div className={styles.column}>
            <div className={styles.card}>
              <div className={styles.subtitle}>
                <div className={`${styles.profile} ${styles.dark}`}>P</div>
                <p>Prilly Tiffani</p>
              </div>
              <div className={styles.text}>
                <h6>
                  A warm and caring Christian community with great sermon.
                </h6>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.subtitle}>
                <div className={styles.profile}>S</div>
                <p>Stevanus Widjaya</p>
              </div>
              <div className={styles.text}>
                <h6>Great preaches and great fellowship</h6>
              </div>
            </div>
          </div>
        </div>
        <a
          href="https://www.google.com/search?sca_esv=8a6dcba95e597810&tbm=lcl&sxsrf=AE3TifNM0SYmATc3__FDu-cHksp78mwEAw:1755943283842&q=International%20Reformed%20Evangelical%20Church%20%28IREC%29%20Stockholm%20Reviews&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIytLAwMzQzMTc2MTWyNLI0sTTawMj4itHJM68ktSgvsSQzPy8xRyEoNS2_KDc1RcG1LDEvPTUnMxko6JxRWpScoaDhGeTqrKkQXJKfnJ2Rn5MLVFyWmVpevIiVCoYAAMHXy3WjAAAA&rldimm=188616473452929492&hl=en-SE&sa=X&ved=0CAYQ5foLahcKEwi4sLm-1qCPAxUAAAAAHQAAAAAQBQ&biw=1920&bih=911&dpr=1#lkt=LocalPoiReviews&arid=ChZDSUhNMG9nS0VJQ0FnSUNmeWQ3cFlREAE"
          className={`${buttonStyles.button}`}
          target="_blank"
          rel="noreferrer"
        >
          Read more on Google Maps
          <i
            className={`${iconStyles.icon} ${styles.icon} ${iconStyles.launch}`}
          ></i>
        </a>
      </div>
    </section>
  );
};

export default Testimonies;
